import React from 'react';
import ReactCodeInput from 'react-code-input';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getErrorMessage } from '../../../utils/errorMessage';
import { sendVerificationCode } from '../../signup.api';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { BrandButton } from '../../../components/button';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import { InjectedIntlProps } from '../../../doctrine.types';

type Props = {
  phoneNumber: string;
  getToNextStep: (param: { isDuplicateSignup: boolean }) => void;
  getToFirstStep: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
  source: string;
  sourcePage: string;
  isICP: boolean;
  user_id: number;
} & InjectedIntlProps;

type State = {
  code: string;
  error: string;
};

export class RawSignUpConfirmPhoneContent extends React.Component<
  Props,
  State
> {
  static defaultProps = {
    isICP: false,
    source: 'signup-phone-modal',
    sourcePage: '',
  };

  state: State = {
    code: '',
    error: '',
  };

  handleChange = (value: string) => {
    this.setState({ code: value, error: '' });
  };

  sendVerificationCode = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const { data } = await sendVerificationCode(
        this.props.phoneNumber,
        this.state.code,
        this.props.user_id,
      );
      doctrineAnalytics('Account SignUpConfirmPhoneValidated', {
        source: this.props.source,
        sourcePage: this.props.sourcePage,
      });
      if (this.props.isICP) {
        doctrineAnalytics('Account ICPSignUpConfirmPhoneValidated', {
          source: this.props.source,
          sourcePage: this.props.sourcePage,
        });
      }
      this.props.getToNextStep({ isDuplicateSignup: data.isDuplicateSignup });
    } catch (error) {
      if (error.response && error.response.data) {
        doctrineAnalytics('Account SignUpConfirmPhoneError', {
          error: error.response.data.error,
          source: this.props.source,
          sourcePage: this.props.sourcePage,
        });
        this.setState({
          error: getErrorMessage(error.response, this.props.intl.formatMessage),
        });
      } else {
        throw error;
      }
    }
  };

  render() {
    const { phoneNumber } = this.props;
    const phoneNumberShow = phoneNumber.substring(0, 8).replace(/\+33/, '0');
    const phoneNumberHidden = phoneNumber
      .substring(8, phoneNumber.length)
      .replace(/[0-9]/g, '*');
    return (
      <>
        <MaterialIcon name="phone_iphone" className="signup-card__icon" />
        <div className="signup-card__title">
          <FormattedMessage id="signup/routes/confirm-phone/SignUpConfirmPhoneContent.tsx/1" />{' '}
          {phoneNumber && `au : ${phoneNumberShow}${phoneNumberHidden}`}
        </div>
        <form onSubmit={this.sendVerificationCode}>
          <div className="signup-form__label">
            <FormattedMessage id="signup/routes/confirm-phone/SignUpConfirmPhoneContent.tsx/2" />
          </div>
          <ReactCodeInput
            type="number"
            fields={4}
            name="input-validation"
            onChange={this.handleChange}
            className="signup-form__validation"
            inputStyle={{
              width: '40px',
              height: '40px',
              margin: '0 8px 24px 0',
              textAlign: 'center',
              fontSize: '28px',
            }}
          />
          {this.state.error && (
            <div className="form-error is-visible signup-form__error">
              {this.state.error}
            </div>
          )}
          <BrandButton type="submit" large>
            <FormattedMessage id="signup/routes/confirm-phone/SignUpConfirmPhoneContent.tsx/3" />
          </BrandButton>
        </form>
        <div className="signup-card__bottom">
          <div>
            <FormattedMessage id="signup/routes/confirm-phone/SignUpConfirmPhoneContent.tsx/4" />
          </div>
          <button
            type="button"
            onClick={this.props.getToFirstStep}
            className="signup-card__bottom__link"
          >
            <FormattedMessage id="signup/routes/confirm-phone/SignUpConfirmPhoneContent.tsx/5" />
          </button>
        </div>
      </>
    );
  }
}

export const SignUpConfirmPhoneContent = injectIntl(
  RawSignUpConfirmPhoneContent,
);
